var TABLE_EVENTS = {
  ROW_CHANGED: "landr-maestro--table-row-changed"
};
export { TABLE_EVENTS };